// extracted by mini-css-extract-plugin
export default {"tableMargin":"form_tableMargin__2w+lg","asterisk":"form_asterisk__6DnM+"};